import { useEffect, useState } from "react";

const useScrollDetect = (
  element: Element,
  onScroll: (amount: number) => void,
) => {
  const [lastScrollTop, setLastScrollTop] = useState(0);

  useEffect(() => {
    const scrolledElement = element || window;
    const handleScroll = () => {
      const scrollTop = element
        ? element.scrollTop
        : window.pageYOffset || document.documentElement.scrollTop;

      onScroll(scrollTop - lastScrollTop);
      setLastScrollTop(scrollTop);
    };

    scrolledElement.addEventListener("scroll", handleScroll);

    // Detach the event listener when the component unmounts
    return () => {
      scrolledElement.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollTop, element, onScroll]);
};

export default useScrollDetect;
